(function(){"use strict";try{if(typeof document!="undefined"){var r=document.createElement("style");r.appendChild(document.createTextNode('@charset "UTF-8";.loader[data-v-128abe69]{width:25px;aspect-ratio:1;border-radius:50%;border:4px solid #fff;animation:l20-1-128abe69 .8s infinite linear alternate,l20-2-128abe69 1.6s infinite linear}@keyframes l20-1-128abe69{0%{clip-path:polygon(50% 50%,0 0,50% 0%,50% 0%,50% 0%,50% 0%,50% 0%)}12.5%{clip-path:polygon(50% 50%,0 0,50% 0%,100% 0%,100% 0%,100% 0%,100% 0%)}25%{clip-path:polygon(50% 50%,0 0,50% 0%,100% 0%,100% 100%,100% 100%,100% 100%)}50%{clip-path:polygon(50% 50%,0 0,50% 0%,100% 0%,100% 100%,50% 100%,0% 100%)}62.5%{clip-path:polygon(50% 50%,100% 0,100% 0%,100% 0%,100% 100%,50% 100%,0% 100%)}75%{clip-path:polygon(50% 50%,100% 100%,100% 100%,100% 100%,100% 100%,50% 100%,0% 100%)}to{clip-path:polygon(50% 50%,50% 100%,50% 100%,50% 100%,50% 100%,50% 100%,0% 100%)}}@keyframes l20-2-128abe69{0%{transform:scaleY(1) rotate(0)}49.99%{transform:scaleY(1) rotate(135deg)}50%{transform:scaleY(-1) rotate(0)}to{transform:scaleY(-1) rotate(-135deg)}}@keyframes plyr-progress{to{background-position:25px 0;background-position:var(--plyr-progress-loading-size,25px) 0}}@keyframes plyr-popup{0%{opacity:.5;transform:translateY(10px)}to{opacity:1;transform:translateY(0)}}@keyframes plyr-fade-in{0%{opacity:0}to{opacity:1}}.plyr{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;align-items:center;direction:ltr;display:flex;flex-direction:column;font-family:inherit;font-family:var(--plyr-font-family,inherit);font-variant-numeric:tabular-nums;font-weight:400;font-weight:var(--plyr-font-weight-regular,400);line-height:1.7;line-height:var(--plyr-line-height,1.7);max-width:100%;min-width:200px;position:relative;text-shadow:none;transition:box-shadow .3s ease;z-index:0}.plyr audio,.plyr iframe,.plyr video{display:block;height:100%;width:100%}.plyr button{font:inherit;line-height:inherit;width:auto}.plyr:focus{outline:0}.plyr--full-ui{box-sizing:border-box}.plyr--full-ui *,.plyr--full-ui :after,.plyr--full-ui :before{box-sizing:inherit}.plyr--full-ui a,.plyr--full-ui button,.plyr--full-ui input,.plyr--full-ui label{touch-action:manipulation}.plyr__badge{background:#4a5464;background:var(--plyr-badge-background,#4a5464);border-radius:2px;border-radius:var(--plyr-badge-border-radius,2px);color:#fff;color:var(--plyr-badge-text-color,#fff);font-size:9px;font-size:var(--plyr-font-size-badge,9px);line-height:1;padding:3px 4px}.plyr--full-ui ::-webkit-media-text-track-container{display:none}.plyr__captions{animation:plyr-fade-in .3s ease;bottom:0;display:none;font-size:13px;font-size:var(--plyr-font-size-small,13px);left:0;padding:10px;padding:var(--plyr-control-spacing,10px);position:absolute;text-align:center;transition:transform .4s ease-in-out;width:100%}.plyr__captions span:empty{display:none}@media (min-width:480px){.plyr__captions{font-size:15px;font-size:var(--plyr-font-size-base,15px);padding:20px;padding:calc(var(--plyr-control-spacing, 10px)*2)}}@media (min-width:768px){.plyr__captions{font-size:18px;font-size:var(--plyr-font-size-large,18px)}}.plyr--captions-active .plyr__captions{display:block}.plyr:not(.plyr--hide-controls) .plyr__controls:not(:empty)~.plyr__captions{transform:translateY(-40px);transform:translateY(calc(var(--plyr-control-spacing, 10px)*-4))}.plyr__caption{background:#000c;background:var(--plyr-captions-background,#000c);border-radius:2px;-webkit-box-decoration-break:clone;box-decoration-break:clone;color:#fff;color:var(--plyr-captions-text-color,#fff);line-height:185%;padding:.2em .5em;white-space:pre-wrap}.plyr__caption div{display:inline}.plyr__control{background:#0000;border:0;border-radius:4px;border-radius:var(--plyr-control-radius,4px);color:inherit;cursor:pointer;flex-shrink:0;overflow:visible;padding:7px;padding:calc(var(--plyr-control-spacing, 10px)*.7);position:relative;transition:all .3s ease}.plyr__control svg{fill:currentColor;display:block;height:18px;height:var(--plyr-control-icon-size,18px);pointer-events:none;width:18px;width:var(--plyr-control-icon-size,18px)}.plyr__control:focus{outline:0}.plyr__control:focus-visible{outline:2px dashed #00b2ff;outline:2px dashed var(--plyr-focus-visible-color,var(--plyr-color-main,var(--plyr-color-main,#00b2ff)));outline-offset:2px}a.plyr__control{text-decoration:none}.plyr__control.plyr__control--pressed .icon--not-pressed,.plyr__control.plyr__control--pressed .label--not-pressed,.plyr__control:not(.plyr__control--pressed) .icon--pressed,.plyr__control:not(.plyr__control--pressed) .label--pressed,a.plyr__control:after,a.plyr__control:before{display:none}.plyr--full-ui ::-webkit-media-controls{display:none}.plyr__controls{align-items:center;display:flex;justify-content:flex-end;text-align:center}.plyr__controls .plyr__progress__container{flex:1;min-width:0}.plyr__controls .plyr__controls__item{margin-left:2.5px;margin-left:calc(var(--plyr-control-spacing, 10px)/4)}.plyr__controls .plyr__controls__item:first-child{margin-left:0;margin-right:auto}.plyr__controls .plyr__controls__item.plyr__progress__container{padding-left:2.5px;padding-left:calc(var(--plyr-control-spacing, 10px)/4)}.plyr__controls .plyr__controls__item.plyr__time{padding:0 5px;padding:0 calc(var(--plyr-control-spacing, 10px)/2)}.plyr__controls .plyr__controls__item.plyr__progress__container:first-child,.plyr__controls .plyr__controls__item.plyr__time+.plyr__time,.plyr__controls .plyr__controls__item.plyr__time:first-child{padding-left:0}.plyr [data-plyr=airplay],.plyr [data-plyr=captions],.plyr [data-plyr=fullscreen],.plyr [data-plyr=pip],.plyr__controls:empty{display:none}.plyr--airplay-supported [data-plyr=airplay],.plyr--captions-enabled [data-plyr=captions],.plyr--fullscreen-enabled [data-plyr=fullscreen],.plyr--pip-supported [data-plyr=pip]{display:inline-block}.plyr__menu{display:flex;position:relative}.plyr__menu .plyr__control svg{transition:transform .3s ease}.plyr__menu .plyr__control[aria-expanded=true] svg{transform:rotate(90deg)}.plyr__menu .plyr__control[aria-expanded=true] .plyr__tooltip{display:none}.plyr__menu__container{animation:plyr-popup .2s ease;background:#ffffffe6;background:var(--plyr-menu-background,#ffffffe6);border-radius:8px;border-radius:var(--plyr-menu-radius,8px);bottom:100%;box-shadow:0 1px 2px #00000026;box-shadow:var(--plyr-menu-shadow,0 1px 2px #00000026);color:#4a5464;color:var(--plyr-menu-color,#4a5464);font-size:15px;font-size:var(--plyr-font-size-base,15px);margin-bottom:10px;position:absolute;right:-3px;text-align:left;white-space:nowrap;z-index:3}.plyr__menu__container>div{overflow:hidden;transition:height .35s cubic-bezier(.4,0,.2,1),width .35s cubic-bezier(.4,0,.2,1)}.plyr__menu__container:after{border:4px solid #0000;border-top-color:#ffffffe6;border:var(--plyr-menu-arrow-size,4px) solid #0000;border-top-color:var(--plyr-menu-background,#ffffffe6);content:"";height:0;position:absolute;right:14px;right:calc(var(--plyr-control-icon-size, 18px)/2 + var(--plyr-control-spacing, 10px)*.7 - var(--plyr-menu-arrow-size, 4px)/2);top:100%;width:0}.plyr__menu__container [role=menu]{padding:7px;padding:calc(var(--plyr-control-spacing, 10px)*.7)}.plyr__menu__container [role=menuitem],.plyr__menu__container [role=menuitemradio]{margin-top:2px}.plyr__menu__container [role=menuitem]:first-child,.plyr__menu__container [role=menuitemradio]:first-child{margin-top:0}.plyr__menu__container .plyr__control{align-items:center;color:#4a5464;color:var(--plyr-menu-color,#4a5464);display:flex;font-size:13px;font-size:var(--plyr-font-size-menu,var(--plyr-font-size-small,13px));padding:4.66667px 10.5px;padding:calc(var(--plyr-control-spacing, 10px)*.7/1.5) calc(var(--plyr-control-spacing, 10px)*.7*1.5);-webkit-user-select:none;user-select:none;width:100%}.plyr__menu__container .plyr__control>span{align-items:inherit;display:flex;width:100%}.plyr__menu__container .plyr__control:after{border:4px solid #0000;border:var(--plyr-menu-item-arrow-size,4px) solid #0000;content:"";position:absolute;top:50%;transform:translateY(-50%)}.plyr__menu__container .plyr__control--forward{padding-right:28px;padding-right:calc(var(--plyr-control-spacing, 10px)*.7*4)}.plyr__menu__container .plyr__control--forward:after{border-left-color:#728197;border-left-color:var(--plyr-menu-arrow-color,#728197);right:6.5px;right:calc(var(--plyr-control-spacing, 10px)*.7*1.5 - var(--plyr-menu-item-arrow-size, 4px))}.plyr__menu__container .plyr__control--forward:focus-visible:after,.plyr__menu__container .plyr__control--forward:hover:after{border-left-color:initial}.plyr__menu__container .plyr__control--back{font-weight:400;font-weight:var(--plyr-font-weight-regular,400);margin:7px;margin:calc(var(--plyr-control-spacing, 10px)*.7);margin-bottom:3.5px;margin-bottom:calc(var(--plyr-control-spacing, 10px)*.7/2);padding-left:28px;padding-left:calc(var(--plyr-control-spacing, 10px)*.7*4);position:relative;width:calc(100% - 14px);width:calc(100% - var(--plyr-control-spacing, 10px)*.7*2)}.plyr__menu__container .plyr__control--back:after{border-right-color:#728197;border-right-color:var(--plyr-menu-arrow-color,#728197);left:6.5px;left:calc(var(--plyr-control-spacing, 10px)*.7*1.5 - var(--plyr-menu-item-arrow-size, 4px))}.plyr__menu__container .plyr__control--back:before{background:#dcdfe5;background:var(--plyr-menu-back-border-color,#dcdfe5);box-shadow:0 1px #fff;box-shadow:0 1px 0 var(--plyr-menu-back-border-shadow-color,#fff);content:"";height:1px;left:0;margin-top:3.5px;margin-top:calc(var(--plyr-control-spacing, 10px)*.7/2);overflow:hidden;position:absolute;right:0;top:100%}.plyr__menu__container .plyr__control--back:focus-visible:after,.plyr__menu__container .plyr__control--back:hover:after{border-right-color:initial}.plyr__menu__container .plyr__control[role=menuitemradio]{padding-left:7px;padding-left:calc(var(--plyr-control-spacing, 10px)*.7)}.plyr__menu__container .plyr__control[role=menuitemradio]:after,.plyr__menu__container .plyr__control[role=menuitemradio]:before{border-radius:100%}.plyr__menu__container .plyr__control[role=menuitemradio]:before{background:#0000001a;content:"";display:block;flex-shrink:0;height:16px;margin-right:10px;margin-right:var(--plyr-control-spacing,10px);transition:all .3s ease;width:16px}.plyr__menu__container .plyr__control[role=menuitemradio]:after{background:#fff;border:0;height:6px;left:12px;opacity:0;top:50%;transform:translateY(-50%) scale(0);transition:transform .3s ease,opacity .3s ease;width:6px}.plyr__menu__container .plyr__control[role=menuitemradio][aria-checked=true]:before{background:#00b2ff;background:var(--plyr-control-toggle-checked-background,var(--plyr-color-main,var(--plyr-color-main,#00b2ff)))}.plyr__menu__container .plyr__control[role=menuitemradio][aria-checked=true]:after{opacity:1;transform:translateY(-50%) scale(1)}.plyr__menu__container .plyr__control[role=menuitemradio]:focus-visible:before,.plyr__menu__container .plyr__control[role=menuitemradio]:hover:before{background:#23282f1a}.plyr__menu__container .plyr__menu__value{align-items:center;display:flex;margin-left:auto;margin-right:-5px;margin-right:calc(var(--plyr-control-spacing, 10px)*.7*-1 - -2px);overflow:hidden;padding-left:24.5px;padding-left:calc(var(--plyr-control-spacing, 10px)*.7*3.5);pointer-events:none}.plyr--full-ui input[type=range]{-webkit-appearance:none;appearance:none;background:#0000;border:0;border-radius:26px;border-radius:calc(var(--plyr-range-thumb-height, 13px)*2);color:#00b2ff;color:var(--plyr-range-fill-background,var(--plyr-color-main,var(--plyr-color-main,#00b2ff)));display:block;height:19px;height:calc(var(--plyr-range-thumb-active-shadow-width, 3px)*2 + var(--plyr-range-thumb-height, 13px));margin:0;min-width:0;padding:0;transition:box-shadow .3s ease;width:100%}.plyr--full-ui input[type=range]::-webkit-slider-runnable-track{background:#0000;background-image:linear-gradient(90deg,currentColor 0,#0000 0);background-image:linear-gradient(to right,currentColor var(--value,0),#0000 var(--value,0));border:0;border-radius:2.5px;border-radius:calc(var(--plyr-range-track-height, 5px)/2);height:5px;height:var(--plyr-range-track-height,5px);-webkit-transition:box-shadow .3s ease;transition:box-shadow .3s ease;-webkit-user-select:none;user-select:none}.plyr--full-ui input[type=range]::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;background:#fff;background:var(--plyr-range-thumb-background,#fff);border:0;border-radius:100%;box-shadow:0 1px 1px #23282f26,0 0 0 1px #23282f33;box-shadow:var(--plyr-range-thumb-shadow,0 1px 1px #23282f26,0 0 0 1px #23282f33);height:13px;height:var(--plyr-range-thumb-height,13px);margin-top:-4px;margin-top:calc((var(--plyr-range-thumb-height, 13px) - var(--plyr-range-track-height, 5px))/2*-1);position:relative;-webkit-transition:all .2s ease;transition:all .2s ease;width:13px;width:var(--plyr-range-thumb-height,13px)}.plyr--full-ui input[type=range]::-moz-range-track{background:#0000;border:0;border-radius:2.5px;border-radius:calc(var(--plyr-range-track-height, 5px)/2);height:5px;height:var(--plyr-range-track-height,5px);-moz-transition:box-shadow .3s ease;transition:box-shadow .3s ease;user-select:none}.plyr--full-ui input[type=range]::-moz-range-thumb{background:#fff;background:var(--plyr-range-thumb-background,#fff);border:0;border-radius:100%;box-shadow:0 1px 1px #23282f26,0 0 0 1px #23282f33;box-shadow:var(--plyr-range-thumb-shadow,0 1px 1px #23282f26,0 0 0 1px #23282f33);height:13px;height:var(--plyr-range-thumb-height,13px);position:relative;-moz-transition:all .2s ease;transition:all .2s ease;width:13px;width:var(--plyr-range-thumb-height,13px)}.plyr--full-ui input[type=range]::-moz-range-progress{background:currentColor;border-radius:2.5px;border-radius:calc(var(--plyr-range-track-height, 5px)/2);height:5px;height:var(--plyr-range-track-height,5px)}.plyr--full-ui input[type=range]::-ms-track{color:#0000}.plyr--full-ui input[type=range]::-ms-fill-upper,.plyr--full-ui input[type=range]::-ms-track{background:#0000;border:0;border-radius:2.5px;border-radius:calc(var(--plyr-range-track-height, 5px)/2);height:5px;height:var(--plyr-range-track-height,5px);-ms-transition:box-shadow .3s ease;transition:box-shadow .3s ease;user-select:none}.plyr--full-ui input[type=range]::-ms-fill-lower{background:#0000;background:currentColor;border:0;border-radius:2.5px;border-radius:calc(var(--plyr-range-track-height, 5px)/2);height:5px;height:var(--plyr-range-track-height,5px);-ms-transition:box-shadow .3s ease;transition:box-shadow .3s ease;user-select:none}.plyr--full-ui input[type=range]::-ms-thumb{background:#fff;background:var(--plyr-range-thumb-background,#fff);border:0;border-radius:100%;box-shadow:0 1px 1px #23282f26,0 0 0 1px #23282f33;box-shadow:var(--plyr-range-thumb-shadow,0 1px 1px #23282f26,0 0 0 1px #23282f33);height:13px;height:var(--plyr-range-thumb-height,13px);margin-top:0;position:relative;-ms-transition:all .2s ease;transition:all .2s ease;width:13px;width:var(--plyr-range-thumb-height,13px)}.plyr--full-ui input[type=range]::-ms-tooltip{display:none}.plyr--full-ui input[type=range]::-moz-focus-outer{border:0}.plyr--full-ui input[type=range]:focus{outline:0}.plyr--full-ui input[type=range]:focus-visible::-webkit-slider-runnable-track{outline:2px dashed #00b2ff;outline:2px dashed var(--plyr-focus-visible-color,var(--plyr-color-main,var(--plyr-color-main,#00b2ff)));outline-offset:2px}.plyr--full-ui input[type=range]:focus-visible::-moz-range-track{outline:2px dashed #00b2ff;outline:2px dashed var(--plyr-focus-visible-color,var(--plyr-color-main,var(--plyr-color-main,#00b2ff)));outline-offset:2px}.plyr--full-ui input[type=range]:focus-visible::-ms-track{outline:2px dashed #00b2ff;outline:2px dashed var(--plyr-focus-visible-color,var(--plyr-color-main,var(--plyr-color-main,#00b2ff)));outline-offset:2px}.plyr__poster{background-color:#000;background-color:var(--plyr-video-background,var(--plyr-video-background,#000));background-position:50% 50%;background-repeat:no-repeat;background-size:contain;height:100%;left:0;opacity:0;position:absolute;top:0;transition:opacity .2s ease;width:100%;z-index:1}.plyr--stopped.plyr__poster-enabled .plyr__poster{opacity:1}.plyr--youtube.plyr--paused.plyr__poster-enabled:not(.plyr--stopped) .plyr__poster{display:none}.plyr__time{font-size:13px;font-size:var(--plyr-font-size-time,var(--plyr-font-size-small,13px))}.plyr__time+.plyr__time:before{content:"⁄";margin-right:10px;margin-right:var(--plyr-control-spacing,10px)}@media (max-width:767px){.plyr__time+.plyr__time{display:none}}.plyr__tooltip{background:#fff;background:var(--plyr-tooltip-background,#fff);border-radius:5px;border-radius:var(--plyr-tooltip-radius,5px);bottom:100%;box-shadow:0 1px 2px #00000026;box-shadow:var(--plyr-tooltip-shadow,0 1px 2px #00000026);color:#4a5464;color:var(--plyr-tooltip-color,#4a5464);font-size:13px;font-size:var(--plyr-font-size-small,13px);font-weight:400;font-weight:var(--plyr-font-weight-regular,400);left:50%;line-height:1.3;margin-bottom:10px;margin-bottom:calc(var(--plyr-control-spacing, 10px)/2*2);opacity:0;padding:5px 7.5px;padding:calc(var(--plyr-control-spacing, 10px)/2) calc(var(--plyr-control-spacing, 10px)/2*1.5);pointer-events:none;position:absolute;transform:translate(-50%,10px) scale(.8);transform-origin:50% 100%;transition:transform .2s ease .1s,opacity .2s ease .1s;white-space:nowrap;z-index:2}.plyr__tooltip:before{border-left:4px solid #0000;border-left:var(--plyr-tooltip-arrow-size,4px) solid #0000;border-right:4px solid #0000;border-right:var(--plyr-tooltip-arrow-size,4px) solid #0000;border-top:4px solid #fff;border-top:var(--plyr-tooltip-arrow-size,4px) solid var(--plyr-tooltip-background,#fff);bottom:-4px;bottom:calc(var(--plyr-tooltip-arrow-size, 4px)*-1);content:"";height:0;left:50%;position:absolute;transform:translate(-50%);width:0;z-index:2}.plyr .plyr__control:focus-visible .plyr__tooltip,.plyr .plyr__control:hover .plyr__tooltip,.plyr__tooltip--visible{opacity:1;transform:translate(-50%) scale(1)}.plyr .plyr__control:hover .plyr__tooltip{z-index:3}.plyr__controls>.plyr__control:first-child .plyr__tooltip,.plyr__controls>.plyr__control:first-child+.plyr__control .plyr__tooltip{left:0;transform:translateY(10px) scale(.8);transform-origin:0 100%}.plyr__controls>.plyr__control:first-child .plyr__tooltip:before,.plyr__controls>.plyr__control:first-child+.plyr__control .plyr__tooltip:before{left:16px;left:calc(var(--plyr-control-icon-size, 18px)/2 + var(--plyr-control-spacing, 10px)*.7)}.plyr__controls>.plyr__control:last-child .plyr__tooltip{left:auto;right:0;transform:translateY(10px) scale(.8);transform-origin:100% 100%}.plyr__controls>.plyr__control:last-child .plyr__tooltip:before{left:auto;right:16px;right:calc(var(--plyr-control-icon-size, 18px)/2 + var(--plyr-control-spacing, 10px)*.7);transform:translate(50%)}.plyr__controls>.plyr__control:first-child .plyr__tooltip--visible,.plyr__controls>.plyr__control:first-child+.plyr__control .plyr__tooltip--visible,.plyr__controls>.plyr__control:first-child+.plyr__control:focus-visible .plyr__tooltip,.plyr__controls>.plyr__control:first-child+.plyr__control:hover .plyr__tooltip,.plyr__controls>.plyr__control:first-child:focus-visible .plyr__tooltip,.plyr__controls>.plyr__control:first-child:hover .plyr__tooltip,.plyr__controls>.plyr__control:last-child .plyr__tooltip--visible,.plyr__controls>.plyr__control:last-child:focus-visible .plyr__tooltip,.plyr__controls>.plyr__control:last-child:hover .plyr__tooltip{transform:translate(0) scale(1)}.plyr__progress{left:6.5px;left:calc(var(--plyr-range-thumb-height, 13px)*.5);margin-right:13px;margin-right:var(--plyr-range-thumb-height,13px);position:relative}.plyr__progress input[type=range],.plyr__progress__buffer{margin-left:-6.5px;margin-left:calc(var(--plyr-range-thumb-height, 13px)*-.5);margin-right:-6.5px;margin-right:calc(var(--plyr-range-thumb-height, 13px)*-.5);width:calc(100% + 13px);width:calc(100% + var(--plyr-range-thumb-height, 13px))}.plyr__progress input[type=range]{position:relative;z-index:2}.plyr__progress .plyr__tooltip{left:0;max-width:120px;overflow-wrap:break-word}.plyr__progress__buffer{-webkit-appearance:none;background:#0000;border:0;border-radius:100px;height:5px;height:var(--plyr-range-track-height,5px);left:0;margin-top:-2.5px;margin-top:calc((var(--plyr-range-track-height, 5px)/2)*-1);padding:0;position:absolute;top:50%}.plyr__progress__buffer::-webkit-progress-bar{background:#0000}.plyr__progress__buffer::-webkit-progress-value{background:currentColor;border-radius:100px;min-width:5px;min-width:var(--plyr-range-track-height,5px);-webkit-transition:width .2s ease;transition:width .2s ease}.plyr__progress__buffer::-moz-progress-bar{background:currentColor;border-radius:100px;min-width:5px;min-width:var(--plyr-range-track-height,5px);-moz-transition:width .2s ease;transition:width .2s ease}.plyr__progress__buffer::-ms-fill{border-radius:100px;-ms-transition:width .2s ease;transition:width .2s ease}.plyr--loading .plyr__progress__buffer{animation:plyr-progress 1s linear infinite;background-image:linear-gradient(-45deg,#23282f99 25%,#0000 0 50%,#23282f99 0 75%,#0000 0,#0000);background-image:linear-gradient(-45deg,var(--plyr-progress-loading-background,#23282f99) 25%,#0000 25%,#0000 50%,var(--plyr-progress-loading-background,#23282f99) 50%,var(--plyr-progress-loading-background,#23282f99) 75%,#0000 75%,#0000);background-repeat:repeat-x;background-size:25px 25px;background-size:var(--plyr-progress-loading-size,25px) var(--plyr-progress-loading-size,25px);color:#0000}.plyr--video.plyr--loading .plyr__progress__buffer{background-color:#ffffff40;background-color:var(--plyr-video-progress-buffered-background,#ffffff40)}.plyr--audio.plyr--loading .plyr__progress__buffer{background-color:#c1c8d199;background-color:var(--plyr-audio-progress-buffered-background,#c1c8d199)}.plyr__progress__marker{background-color:#fff;background-color:var(--plyr-progress-marker-background,#fff);border-radius:1px;height:5px;height:var(--plyr-range-track-height,5px);position:absolute;top:50%;transform:translate(-50%,-50%);width:3px;width:var(--plyr-progress-marker-width,3px);z-index:3}.plyr__volume{align-items:center;display:flex;position:relative}.plyr__volume input[type=range]{margin-left:5px;margin-left:calc(var(--plyr-control-spacing, 10px)/2);margin-right:5px;margin-right:calc(var(--plyr-control-spacing, 10px)/2);max-width:90px;min-width:60px;position:relative;z-index:2}.plyr--audio{display:block}.plyr--audio .plyr__controls{background:#fff;background:var(--plyr-audio-controls-background,#fff);border-radius:inherit;color:#4a5464;color:var(--plyr-audio-control-color,#4a5464);padding:10px;padding:var(--plyr-control-spacing,10px)}.plyr--audio .plyr__control:focus-visible,.plyr--audio .plyr__control:hover,.plyr--audio .plyr__control[aria-expanded=true]{background:#00b2ff;background:var(--plyr-audio-control-background-hover,var(--plyr-color-main,var(--plyr-color-main,#00b2ff)));color:#fff;color:var(--plyr-audio-control-color-hover,#fff)}.plyr--full-ui.plyr--audio input[type=range]::-webkit-slider-runnable-track{background-color:#c1c8d199;background-color:var(--plyr-audio-range-track-background,var(--plyr-audio-progress-buffered-background,#c1c8d199))}.plyr--full-ui.plyr--audio input[type=range]::-moz-range-track{background-color:#c1c8d199;background-color:var(--plyr-audio-range-track-background,var(--plyr-audio-progress-buffered-background,#c1c8d199))}.plyr--full-ui.plyr--audio input[type=range]::-ms-track{background-color:#c1c8d199;background-color:var(--plyr-audio-range-track-background,var(--plyr-audio-progress-buffered-background,#c1c8d199))}.plyr--full-ui.plyr--audio input[type=range]:active::-webkit-slider-thumb{box-shadow:0 1px 1px #23282f26,0 0 0 1px #23282f33,0 0 0 3px #23282f1a;box-shadow:var(--plyr-range-thumb-shadow,0 1px 1px #23282f26,0 0 0 1px #23282f33),0 0 0 var(--plyr-range-thumb-active-shadow-width,3px) var(--plyr-audio-range-thumb-active-shadow-color,#23282f1a)}.plyr--full-ui.plyr--audio input[type=range]:active::-moz-range-thumb{box-shadow:0 1px 1px #23282f26,0 0 0 1px #23282f33,0 0 0 3px #23282f1a;box-shadow:var(--plyr-range-thumb-shadow,0 1px 1px #23282f26,0 0 0 1px #23282f33),0 0 0 var(--plyr-range-thumb-active-shadow-width,3px) var(--plyr-audio-range-thumb-active-shadow-color,#23282f1a)}.plyr--full-ui.plyr--audio input[type=range]:active::-ms-thumb{box-shadow:0 1px 1px #23282f26,0 0 0 1px #23282f33,0 0 0 3px #23282f1a;box-shadow:var(--plyr-range-thumb-shadow,0 1px 1px #23282f26,0 0 0 1px #23282f33),0 0 0 var(--plyr-range-thumb-active-shadow-width,3px) var(--plyr-audio-range-thumb-active-shadow-color,#23282f1a)}.plyr--audio .plyr__progress__buffer{color:#c1c8d199;color:var(--plyr-audio-progress-buffered-background,#c1c8d199)}.plyr--video{overflow:hidden}.plyr--video.plyr--menu-open{overflow:visible}.plyr__video-wrapper{background:#000;background:var(--plyr-video-background,var(--plyr-video-background,#000));border-radius:inherit;height:100%;margin:auto;overflow:hidden;position:relative;width:100%}.plyr__video-embed,.plyr__video-wrapper--fixed-ratio{aspect-ratio:16/9}@supports not (aspect-ratio:16/9){.plyr__video-embed,.plyr__video-wrapper--fixed-ratio{height:0;padding-bottom:56.25%;position:relative}}.plyr__video-embed iframe,.plyr__video-wrapper--fixed-ratio video{border:0;height:100%;left:0;position:absolute;top:0;width:100%}.plyr--full-ui .plyr__video-embed>.plyr__video-embed__container{padding-bottom:240%;position:relative;transform:translateY(-38.28125%)}.plyr--video .plyr__controls{background:linear-gradient(#0000,#000000bf);background:var(--plyr-video-controls-background,linear-gradient(#0000,#000000bf));border-bottom-left-radius:inherit;border-bottom-right-radius:inherit;bottom:0;color:#fff;color:var(--plyr-video-control-color,#fff);left:0;padding:5px;padding:calc(var(--plyr-control-spacing, 10px)/2);padding-top:20px;padding-top:calc(var(--plyr-control-spacing, 10px)*2);position:absolute;right:0;transition:opacity .4s ease-in-out,transform .4s ease-in-out;z-index:3}@media (min-width:480px){.plyr--video .plyr__controls{padding:10px;padding:var(--plyr-control-spacing,10px);padding-top:35px;padding-top:calc(var(--plyr-control-spacing, 10px)*3.5)}}.plyr--video.plyr--hide-controls .plyr__controls{opacity:0;pointer-events:none;transform:translateY(100%)}.plyr--video .plyr__control:focus-visible,.plyr--video .plyr__control:hover,.plyr--video .plyr__control[aria-expanded=true]{background:#00b2ff;background:var(--plyr-video-control-background-hover,var(--plyr-color-main,var(--plyr-color-main,#00b2ff)));color:#fff;color:var(--plyr-video-control-color-hover,#fff)}.plyr__control--overlaid{background:#00b2ff;background:var(--plyr-video-control-background-hover,var(--plyr-color-main,var(--plyr-color-main,#00b2ff)));border:0;border-radius:100%;color:#fff;color:var(--plyr-video-control-color,#fff);display:none;left:50%;opacity:.9;padding:15px;padding:calc(var(--plyr-control-spacing, 10px)*1.5);position:absolute;top:50%;transform:translate(-50%,-50%);transition:.3s;z-index:2}.plyr__control--overlaid svg{left:2px;position:relative}.plyr__control--overlaid:focus,.plyr__control--overlaid:hover{opacity:1}.plyr--playing .plyr__control--overlaid{opacity:0;visibility:hidden}.plyr--full-ui.plyr--video .plyr__control--overlaid{display:block}.plyr--full-ui.plyr--video input[type=range]::-webkit-slider-runnable-track{background-color:#ffffff40;background-color:var(--plyr-video-range-track-background,var(--plyr-video-progress-buffered-background,#ffffff40))}.plyr--full-ui.plyr--video input[type=range]::-moz-range-track{background-color:#ffffff40;background-color:var(--plyr-video-range-track-background,var(--plyr-video-progress-buffered-background,#ffffff40))}.plyr--full-ui.plyr--video input[type=range]::-ms-track{background-color:#ffffff40;background-color:var(--plyr-video-range-track-background,var(--plyr-video-progress-buffered-background,#ffffff40))}.plyr--full-ui.plyr--video input[type=range]:active::-webkit-slider-thumb{box-shadow:0 1px 1px #23282f26,0 0 0 1px #23282f33,0 0 0 3px #ffffff80;box-shadow:var(--plyr-range-thumb-shadow,0 1px 1px #23282f26,0 0 0 1px #23282f33),0 0 0 var(--plyr-range-thumb-active-shadow-width,3px) var(--plyr-audio-range-thumb-active-shadow-color,#ffffff80)}.plyr--full-ui.plyr--video input[type=range]:active::-moz-range-thumb{box-shadow:0 1px 1px #23282f26,0 0 0 1px #23282f33,0 0 0 3px #ffffff80;box-shadow:var(--plyr-range-thumb-shadow,0 1px 1px #23282f26,0 0 0 1px #23282f33),0 0 0 var(--plyr-range-thumb-active-shadow-width,3px) var(--plyr-audio-range-thumb-active-shadow-color,#ffffff80)}.plyr--full-ui.plyr--video input[type=range]:active::-ms-thumb{box-shadow:0 1px 1px #23282f26,0 0 0 1px #23282f33,0 0 0 3px #ffffff80;box-shadow:var(--plyr-range-thumb-shadow,0 1px 1px #23282f26,0 0 0 1px #23282f33),0 0 0 var(--plyr-range-thumb-active-shadow-width,3px) var(--plyr-audio-range-thumb-active-shadow-color,#ffffff80)}.plyr--video .plyr__progress__buffer{color:#ffffff40;color:var(--plyr-video-progress-buffered-background,#ffffff40)}.plyr:fullscreen{background:#000;border-radius:0!important;height:100%;margin:0;width:100%}.plyr:fullscreen video{height:100%}.plyr:fullscreen .plyr__control .icon--exit-fullscreen{display:block}.plyr:fullscreen .plyr__control .icon--exit-fullscreen+svg{display:none}.plyr:fullscreen.plyr--hide-controls{cursor:none}@media (min-width:1024px){.plyr:fullscreen .plyr__captions{font-size:21px;font-size:var(--plyr-font-size-xlarge,21px)}}.plyr--fullscreen-fallback{background:#000;border-radius:0!important;height:100%;inset:0;margin:0;position:fixed;width:100%;z-index:10000000}.plyr--fullscreen-fallback video{height:100%}.plyr--fullscreen-fallback .plyr__control .icon--exit-fullscreen{display:block}.plyr--fullscreen-fallback .plyr__control .icon--exit-fullscreen+svg{display:none}.plyr--fullscreen-fallback.plyr--hide-controls{cursor:none}@media (min-width:1024px){.plyr--fullscreen-fallback .plyr__captions{font-size:21px;font-size:var(--plyr-font-size-xlarge,21px)}}.plyr__ads{border-radius:inherit;cursor:pointer;inset:0;overflow:hidden;position:absolute;z-index:-1}.plyr__ads>div,.plyr__ads>div iframe{height:100%;position:absolute;width:100%}.plyr__ads:after{background:#23282f;border-radius:2px;bottom:10px;bottom:var(--plyr-control-spacing,10px);color:#fff;content:attr(data-badge-text);font-size:11px;padding:2px 6px;pointer-events:none;position:absolute;right:10px;right:var(--plyr-control-spacing,10px);z-index:3}.plyr__ads:empty:after{display:none}.plyr__cues{background:currentColor;display:block;height:5px;height:var(--plyr-range-track-height,5px);left:0;opacity:.8;position:absolute;top:50%;transform:translateY(-50%);width:3px;z-index:3}.plyr__preview-thumb{background-color:#fff;background-color:var(--plyr-tooltip-background,#fff);border-radius:8px;border-radius:var(--plyr-menu-radius,8px);bottom:100%;box-shadow:0 1px 2px #00000026;box-shadow:var(--plyr-tooltip-shadow,0 1px 2px #00000026);margin-bottom:10px;margin-bottom:calc(var(--plyr-control-spacing, 10px)/2*2);opacity:0;padding:3px;pointer-events:none;position:absolute;transform:translateY(10px) scale(.8);transform-origin:50% 100%;transition:transform .2s ease .1s,opacity .2s ease .1s;z-index:2}.plyr__preview-thumb--is-shown{opacity:1;transform:translate(0) scale(1)}.plyr__preview-thumb:before{border-left:4px solid #0000;border-left:var(--plyr-tooltip-arrow-size,4px) solid #0000;border-right:4px solid #0000;border-right:var(--plyr-tooltip-arrow-size,4px) solid #0000;border-top:4px solid #fff;border-top:var(--plyr-tooltip-arrow-size,4px) solid var(--plyr-tooltip-background,#fff);bottom:-4px;bottom:calc(var(--plyr-tooltip-arrow-size, 4px)*-1);content:"";height:0;left:calc(50% + var(--preview-arrow-offset));position:absolute;transform:translate(-50%);width:0;z-index:2}.plyr__preview-thumb__image-container{background:#c1c8d1;border-radius:7px;border-radius:calc(var(--plyr-menu-radius, 8px) - 1px);overflow:hidden;position:relative;z-index:0}.plyr__preview-thumb__image-container img,.plyr__preview-thumb__image-container:after{height:100%;left:0;position:absolute;top:0;width:100%}.plyr__preview-thumb__image-container:after{border-radius:inherit;box-shadow:inset 0 0 0 1px #00000026;content:"";pointer-events:none}.plyr__preview-thumb__image-container img{max-height:none;max-width:none}.plyr__preview-thumb__time-container{background:linear-gradient(#0000,#000000bf);background:var(--plyr-video-controls-background,linear-gradient(#0000,#000000bf));border-bottom-left-radius:7px;border-bottom-left-radius:calc(var(--plyr-menu-radius, 8px) - 1px);border-bottom-right-radius:7px;border-bottom-right-radius:calc(var(--plyr-menu-radius, 8px) - 1px);bottom:0;left:0;line-height:1.1;padding:20px 6px 6px;position:absolute;right:0;z-index:3}.plyr__preview-thumb__time-container span{color:#fff;font-size:13px;font-size:var(--plyr-font-size-time,var(--plyr-font-size-small,13px))}.plyr__preview-scrubbing{filter:blur(1px);height:100%;inset:0;margin:auto;opacity:0;overflow:hidden;pointer-events:none;position:absolute;transition:opacity .3s ease;width:100%;z-index:1}.plyr__preview-scrubbing--is-shown{opacity:1}.plyr__preview-scrubbing img{height:100%;left:0;max-height:none;max-width:none;object-fit:contain;position:absolute;top:0;width:100%}.plyr--no-transition{transition:none!important}.plyr__sr-only{clip:rect(1px,1px,1px,1px);border:0!important;height:1px!important;overflow:hidden;padding:0!important;position:absolute!important;width:1px!important}.plyr [hidden],.hide{display:none!important}.video-loader{aspect-ratio:16/9;height:100%;width:100%;display:flex;justify-content:center;align-items:center;flex-direction:column;background-color:#000;color:#fff;border-radius:var(--border-radius);text-align:center}.error-screen{font-size:min(4vw,20px);padding:20px;text-align:center;color:#fff}.error-screen .title{font-size:1em;font-weight:700;margin-bottom:.25em}.error-screen .description{font-size:.75em;opacity:.8}.status-screen{font-size:min(4vw,20px);padding:20px;text-align:center}.status-screen .title{font-size:1em;font-weight:700;margin-bottom:.25em}.status-screen .description{font-size:.75em;opacity:.8}.video-player-container{--plyr-color-main: var(--theme-color);--plyr-captions-background: transparent;--plyr-captions-text-color: #fff;--plyr-font-size: 22px;--plyr-font-weight: 800;--plyr-captions-padding: 0px;--plyr-captions-letter-spacing: .6px;--plyr-captions-line-height: 1.5;--plyr-captions-max-width: 90%;--plyr-captions-margin: 0 auto;--plyr-captions-text-shadow: 2px 2px 4px rgba(0, 0, 0, 1), -2px -2px 4px rgba(0, 0, 0, 1), -2px 2px 4px rgba(0, 0, 0, 1), 2px -2px 4px rgba(0, 0, 0, 1), 0 0 10px rgba(0, 0, 0, 1), 1px 1px 0 #000, -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 0 0 8px rgba(0, 0, 0, 1)}.video-player-container #plyr-video,.video-player-container .plyr__video-wrapper{aspect-ratio:16/9}.video-player-container .plyr__captions{bottom:0;padding:var(--plyr-captions-padding)}.video-player-container .plyr__captions .plyr__caption{background-color:transparent!important;text-shadow:var(--plyr-captions-text-shadow)!important;font-weight:var(--plyr-font-weight)!important;word-spacing:1px;padding:2px 6px;line-height:normal}.video-player-container .plyr.plyr--video{border-radius:var(--border-radius)}.video-player-container .plyr__menu__container{background:var(--controls-bg-color);border-radius:var(--border-radius)}.video-player-container .plyr__menu__container [role=menu]{max-height:10rem;overflow-y:auto}.video-player-container .plyr__menu__container button:hover{background-color:color-mix(in srgb,var(--theme-color) 58%,transparent)}.video-player-container .plyr--video .plyr__controls{padding:5px;background:var(--controls-bg-color)}.video-player-container .plyr--full-ui .plyr__volume input{display:none}.video-player-container .plyr__volume:hover input{display:block;position:absolute;left:-106%;top:-174%;transform:rotate(270deg);background:var(--controls-bg-color);padding:5px;border-radius:0;width:100px;height:22px}.video-player-container .plyr__menu__container .plyr__control{background:var(--controls-bg-color)}.video-player-container [role=menu] button,.video-player-container .plyr__menu__container .plyr__control{color:var(--text-color)}.video-player-container .plyr__control.plyr__control--overlaid{background-color:#dbdbdb}.video-player-container .plyr__control.plyr__control--overlaid svg{mix-blend-mode:difference}.hide{display:none!important}.image-loader{aspect-ratio:16/9;height:100%;width:100%;display:flex;justify-content:center;align-items:center;background-color:#000;color:#fff;border-radius:var(--border-radius)}.viewer-image{width:100%;height:100%;object-fit:contain;background-color:#000}.asset-canvas[data-v-dba5cb7a]{aspect-ratio:16/9;height:100%;display:flex;justify-content:center;align-items:center;background-color:#000;color:#fff;border-radius:var(--border-radius);font-size:1em;font-weight:700}')),document.head.appendChild(r)}}catch(o){console.error("vite-plugin-css-injected-by-js",o)}})();
var et = Object.defineProperty, tt = Object.defineProperties;
var at = Object.getOwnPropertyDescriptors;
var we = Object.getOwnPropertySymbols;
var nt = Object.prototype.hasOwnProperty, it = Object.prototype.propertyIsEnumerable;
var ee = (i, e, a) => e in i ? et(i, e, { enumerable: !0, configurable: !0, writable: !0, value: a }) : i[e] = a, I = (i, e) => {
  for (var a in e || (e = {}))
    nt.call(e, a) && ee(i, a, e[a]);
  if (we)
    for (var a of we(e))
      it.call(e, a) && ee(i, a, e[a]);
  return i;
}, U = (i, e) => tt(i, at(e));
var E = (i, e, a) => ee(i, typeof e != "symbol" ? e + "" : e, a);
var v = (i, e, a) => new Promise((t, s) => {
  var d = (o) => {
    try {
      u(a.next(o));
    } catch (l) {
      s(l);
    }
  }, f = (o) => {
    try {
      u(a.throw(o));
    } catch (l) {
      s(l);
    }
  }, u = (o) => o.done ? t(o.value) : Promise.resolve(o.value).then(d, f);
  u((a = a.apply(i, e)).next());
});
import { createElementBlock as C, openBlock as S, defineComponent as re, ref as g, computed as N, watch as te, nextTick as Ee, onMounted as oe, onBeforeUnmount as Se, Fragment as ae, createElementVNode as B, normalizeStyle as V, normalizeClass as q, createCommentVNode as H, createBlock as ne, toDisplayString as ie, unref as k, renderList as st, createVNode as Pe, watchEffect as rt } from "vue";
import { P as F, g as ot, f as be, c as ke } from "./index-BmGD5jiK.js";
import { _ as Ce } from "./_plugin-vue_export-helper-CHgC5LLL.js";
import { v as lt, u as ct } from "./useAssetPlayer-DXalh3Ib.js";
import { E as W, H as _, P as ut } from "./vod-vendor-BMcDEz2Z.js";
function dt(i, e) {
  let a = null;
  return function(...t) {
    const s = () => {
      a = null, i(...t);
    };
    a !== null && clearTimeout(a), a = setTimeout(s, e);
  };
}
const ft = {}, ht = { class: "loader" };
function mt(i, e) {
  return S(), C("div", ht);
}
const le = /* @__PURE__ */ Ce(ft, [["render", mt], ["__scopeId", "data-v-128abe69"]]), $ = {
  mp4: "video/mp4",
  webm: "video/webm",
  // quicktime is not supported by mulitple browsers. Playing .mov files with mp4 type works in all browsers
  mov: "video/mp4"
}, Te = (i) => {
  const e = i.split(".");
  return e[e.length - 1];
}, vt = (i) => {
  if (!i) return $.mp4;
  const e = new URL(i).pathname.split("/"), a = e[e.length - 1];
  return $[Te(a)] ? $[Te(a)] : $.mp4;
}, gt = () => v(void 0, null, function* () {
  document.pictureInPictureElement && (yield document.exitPictureInPicture());
}), Re = (i, e) => !!e || i === F.COMPLETED, yt = (i, e, a) => i === F.UNCODABLE || (i === F.ERROR || i === F.PROCESSING) && se(4 * 60, e, a), se = (i, e, a) => (/* @__PURE__ */ new Date()).getTime() - new Date(a != null ? a : e).getTime() > i * 60 * 1e3;
function pt(i, e) {
  return !Re(i, e);
}
function wt(i, e, a) {
  const t = se(
    240,
    e,
    a
  ), s = se(
    1,
    e,
    a
  );
  if (t)
    return { title: "This video can't be processed. Please upload again." };
  switch (i) {
    case F.COMPLETED:
      return { title: "Ready to play!" };
    case F.REMAINING:
      return {
        title: "Queued for processing...",
        description: s && "You can close this window while we transcode your video. It may take a few hours, depending on the size. Check back for updates!"
      };
    case F.UNCODABLE:
      return { title: "This video can't be processed. Please upload again" };
    case F.PROCESSING:
      return {
        title: "Transcoding in progress...",
        description: s && "You can close this window while we transcode your video. It may take a few hours, depending on the size. Check back for updates!"
      };
    case F.ERROR:
      return {
        title: "There was an error, retrying...",
        description: s && "You can close this window while we transcode your video. It may take a few hours, depending on the size. Check back for updates!"
      };
    default:
      return {
        title: "Video added. We will start processing shortly.",
        description: s && "You can close this window while we transcode your video. It may take a few hours, depending on the size. Check back for updates!"
      };
  }
}
function bt(i) {
  i && i.startsWith("blob:") && URL.revokeObjectURL(i);
}
function kt(a) {
  return v(this, arguments, function* (i, e = []) {
    if (!i || Object.keys(i).length === 0)
      return { captions: [], blobUrls: [] };
    e.length = 0;
    const t = Object.entries(i).map((o) => v(this, [o], function* ([f, u]) {
      try {
        const l = Et(f), w = f.includes("_") ? f.split("_")[0] : f, b = yield St(u);
        return b ? (e.push(b.webVttUrl), {
          kind: "captions",
          label: l,
          srcLang: w,
          src: b.webVttUrl,
          default: f === "en"
        }) : null;
      } catch (l) {
        return null;
      }
    }));
    return { captions: (yield Promise.all(t)).filter(Boolean), blobUrls: e };
  });
}
function Tt(i) {
  i.forEach((e) => bt(e));
}
function Et(i) {
  return {
    en: "English",
    es: "Spanish",
    fr: "French",
    de: "German",
    it: "Italian",
    nl: "Dutch",
    pt: "Portuguese",
    sv: "Swedish",
    no: "Norwegian",
    fi: "Finnish",
    da: "Danish"
  }[i] || i.toUpperCase();
}
function St(i) {
  return v(this, null, function* () {
    try {
      const e = yield fetch(i);
      if (!e.ok)
        throw new Error(
          `Failed to fetch SRT file: ${e.status} ${e.statusText}`
        );
      const a = yield e.text();
      let t = `WEBVTT

`;
      const s = a.trim().split(/\r?\n\r?\n/);
      for (const u of s) {
        const o = u.split(/\r?\n/);
        if (o.length >= 2) {
          let l = o[1];
          l = l.replace(/,/g, "."), t += l + `
`;
          for (let w = 2; w < o.length; w++)
            t += o[w] + `
`;
          t += `
`;
        }
      }
      const d = new Blob([t], { type: "text/vtt" });
      return { webVttUrl: URL.createObjectURL(d) };
    } catch (e) {
      return null;
    }
  });
}
let Le = !1, j = !1, ce = !1, xe = {
  isNativePlatform: () => !1,
  getPlatform: () => "web"
}, G = {
  lock: () => v(void 0, null, function* () {
  }),
  addListener: () => ({ remove: () => {
  } }),
  removeAllListeners: () => v(void 0, null, function* () {
  })
}, ue = {
  show: () => v(void 0, null, function* () {
  }),
  hide: () => v(void 0, null, function* () {
  })
};
const Ie = [], Pt = () => v(void 0, null, function* () {
  try {
    const i = yield import("./index-aAdlXYiR.js").catch(() => null);
    if (i) {
      xe = i.Capacitor, Le = !0;
      try {
        const e = yield import("./index-G1oNh_cu.js").catch(
          () => null
        );
        e && (ue = e.StatusBar, ce = !0);
      } catch (e) {
      }
      try {
        const e = yield import("./index-DLTLHRap.js").catch(() => null);
        e && (G = e.ScreenOrientation, j = !0);
      } catch (e) {
      }
    }
  } catch (i) {
  }
});
Pt().catch((i) => {
});
const M = () => Le && xe.isNativePlatform(), z = (i) => v(void 0, null, function* () {
  if (M() && j)
    try {
      yield G.lock({ orientation: i });
    } catch (e) {
    }
}), Ct = (i) => {
  if (M() && j)
    try {
      const e = G.addListener(
        "screenOrientationChange",
        i
      );
      Ie.push(e);
    } catch (e) {
    }
}, Oe = () => {
  if (M() && j)
    try {
      G.removeAllListeners();
    } catch (i) {
    }
}, Rt = () => v(void 0, null, function* () {
  if (M() && ce)
    try {
      yield ue.hide();
    } catch (i) {
    }
}), Lt = () => v(void 0, null, function* () {
  if (M() && ce)
    try {
      yield ue.show();
    } catch (i) {
    }
}), xt = () => {
  Oe(), Ie.forEach((i) => {
    try {
      i && typeof i.remove == "function" && i.remove();
    } catch (e) {
    }
  });
};
class It {
  // Tracking views in 1% increments (100 segments)
  constructor(e) {
    E(this, "analytics");
    E(this, "bufferingEvents", []);
    E(this, "errorEvents", []);
    E(this, "seekEvents", []);
    E(this, "qualityChangeEvents", []);
    E(this, "playPauseEvents", []);
    E(this, "fullscreenEvents", []);
    E(this, "captionEvents", []);
    E(this, "buffering", !1);
    E(this, "bufferingStartTime", 0);
    E(this, "currentQuality", null);
    E(this, "startTime");
    E(this, "tracker", null);
    E(this, "isPlaying", !1);
    E(this, "isSeeking", !1);
    E(this, "viewMap", /* @__PURE__ */ new Map());
    this.analytics = {
      sessionId: this.generateSessionId(),
      licenseId: e,
      serviceInitTimestamp: performance.now(),
      totalWatchTimeSecs: 0,
      totalBufferingTimeSecs: 0,
      totalSessionDurationSecs: 0,
      totalBufferingCount: 0,
      totalSeekCount: 0,
      totalErrorCount: 0,
      totalFatalErrorsCount: 0,
      totalNonFatalErrorsCount: 0,
      totalQualityChangeCount: 0,
      watchTimePerQualitySecs: {},
      bufferingPerQualitySecs: {},
      totalDurationPerQualitySecs: {},
      playPauseCount: 0,
      fullscreenCount: 0,
      currentTime: 0,
      duration: 0,
      completionPercentage: 0,
      uxScore: 0,
      hotSpots: {},
      mostWatchedSegment: 0,
      platform: this.detectPlatform(),
      networkInfo: this.getNetworkInfo(),
      deviceInfo: this.getDeviceInfo(),
      usedStandardPlayback: !1,
      errors: [],
      playbackFluidityIndex: 100,
      startTimeUTC: Date.now()
    };
  }
  // Initialize with player instance
  init(e) {
    e && (this.startTime = performance.now(), this.analytics.startTimeUTC = Date.now(), this.registerPlayerEvents(e));
  }
  startTracker() {
    this.tracker && this.stopTracker(), this.tracker = setInterval(() => {
      if (this.currentQuality) {
        const e = `${this.currentQuality.resolution}p`;
        this.analytics.totalDurationPerQualitySecs[e] = (this.analytics.totalDurationPerQualitySecs[e] || 0) + 1;
      }
      if (this.isPlaying && !this.isSeeking && !this.buffering) {
        if (this.analytics.totalWatchTimeSecs += 1, this.currentQuality) {
          const e = `${this.currentQuality.resolution}p`;
          this.analytics.watchTimePerQualitySecs[e] = (this.analytics.watchTimePerQualitySecs[e] || 0) + 1;
        }
        this.updatePlaybackStats(
          this.analytics.currentTime,
          this.analytics.duration
        );
      }
    }, 1e3);
  }
  stopTracker() {
    this.tracker && (clearInterval(this.tracker), this.tracker = null);
  }
  markPlayerReady() {
    try {
      this.analytics.timeToReadyPlayerSecs || (this.analytics.timeToReadyPlayerSecs = (performance.now() - this.startTime) / 1e3);
    } catch (e) {
    }
  }
  markFirstFrameRendered() {
    try {
      this.analytics.timeToRenderFirstFrameSecs || (this.analytics.timeToRenderFirstFrameSecs = (performance.now() - this.startTime) / 1e3);
    } catch (e) {
    }
  }
  startBuffering(e) {
    this.buffering || (this.buffering = !0, this.bufferingStartTime = performance.now(), this.bufferingEvents.push({
      timestamp: this.bufferingStartTime,
      duration: 0,
      quality: e
    }));
  }
  endBuffering() {
    this.buffering && (this.buffering = !1, this.analytics.totalBufferingCount++);
  }
  trackSeek(e, a) {
    try {
      if (this.seekEvents.push({
        timestamp: performance.now(),
        from: e,
        to: a
      }), this.analytics.duration && this.analytics.duration > 0) {
        const t = Math.floor(a / this.analytics.duration * 100);
        this.viewMap.set(
          t,
          (this.viewMap.get(t) || 0) + 3
        );
      }
    } catch (t) {
    }
  }
  trackError(e, a, t = !1) {
    this.errorEvents.push({
      timestamp: performance.now(),
      code: e,
      message: a,
      fatal: t
    }), t ? this.analytics.totalFatalErrorsCount++ : this.analytics.totalNonFatalErrorsCount++, this.analytics.errors.push({
      timestamp: performance.now(),
      code: e,
      message: a,
      fatal: t
    });
  }
  trackQualityChange(e, a) {
    this.currentQuality = a, this.initializeQualityTracking(a), this.qualityChangeEvents.push({
      timestamp: performance.now(),
      from: e,
      to: a
    });
  }
  trackPlayPause(e) {
    this.playPauseEvents.push({
      timestamp: performance.now(),
      action: e
    });
  }
  trackFullscreen(e) {
    this.fullscreenEvents.push({
      timestamp: performance.now(),
      isFullscreen: e
    });
  }
  trackCaptionUsage(e, a) {
    this.captionEvents.push({
      timestamp: performance.now(),
      enabled: e,
      language: a
    });
  }
  updatePlaybackStats(e, a) {
    try {
      if (!e || !a)
        return;
      if (this.analytics.currentTime = e || 0, this.analytics.duration = a || 0, a > 0) {
        this.analytics.completionPercentage = e / a * 100;
        const t = Math.floor(e / a * 100);
        this.viewMap.set(
          t,
          (this.viewMap.get(t) || 0) + 1
        );
      }
    } catch (t) {
    }
  }
  setUsedStandardPlayback(e) {
    this.analytics.usedStandardPlayback = e;
  }
  /**
   * Creates normalized and sorted hot-spots data from the view counts
   * @param viewMap The map of segment positions to view counts
   * @returns Object containing hot-spots data and the most watched segment
   */
  normalizeAndSortHotSpots(e) {
    const a = Array.from(e.values()), t = Math.max(...a, 1);
    let s = 0, d = 0;
    const f = {};
    for (let l = 0; l < 100; l++)
      f[`${l}`] = 0;
    e.forEach((l, w) => {
      const b = Math.round(l / t * 100);
      f[`${w}`] = b, b > d && (d = b, s = w);
    });
    const u = Object.keys(f).sort(
      (l, w) => parseInt(l) - parseInt(w)
    ), o = {};
    for (const l of u)
      o[l] = f[l];
    return {
      hotSpots: o,
      mostWatchedSegment: s
    };
  }
  /**
   * Calculates buffering time per quality and total buffering time
   * @returns Object containing bufferingPerQualitySecs and totalBufferingTimeSecs
   */
  calculateBufferingTime() {
    const e = {};
    Object.keys(this.analytics.totalDurationPerQualitySecs).forEach((t) => {
      const s = this.analytics.totalDurationPerQualitySecs[t] || 0, d = this.analytics.watchTimePerQualitySecs[t] || 0, f = Math.max(0, s - d);
      e[t] = f;
    });
    const a = Object.values(
      e
    ).reduce((t, s) => t + s, 0);
    return {
      bufferingPerQualitySecs: e,
      totalBufferingTimeSecs: a
    };
  }
  /**
   * Determines the most frequently used caption language
   * @returns The most used caption language or undefined if no captions used
   */
  determineMostUsedCaption() {
    if (this.captionEvents.length === 0)
      return;
    const e = /* @__PURE__ */ new Map();
    if (this.captionEvents.filter((t) => t.enabled && t.language).forEach((t) => {
      t.language && e.set(t.language, (e.get(t.language) || 0) + 1);
    }), e.size === 0)
      return;
    const a = Array.from(e.entries()).sort(
      (t, s) => s[1] - t[1]
    );
    return a.length > 0 ? a[0][0] : void 0;
  }
  /**
   * Determines the most frequently used video resolution
   * @returns The most used resolution or undefined if no resolution data available
   */
  determineMostUsedResolution() {
    var t;
    const e = this.analytics.watchTimePerQualitySecs;
    if (!e || Object.keys(e).length === 0)
      return;
    const a = Object.entries(e).sort(
      (s, d) => d[1] - s[1]
    );
    return a.length > 0 ? (t = a[0]) == null ? void 0 : t[0] : void 0;
  }
  registerPlayerEvents(e) {
    e && (e.on("ready", () => {
      this.markPlayerReady();
    }), e.on("play", () => {
      this.startTracker();
    }), e.on("loadeddata", () => this.markFirstFrameRendered()), e.on("waiting", () => this.startBuffering()), e.on("playing", () => {
      this.endBuffering(), this.trackPlayPause("play"), this.isPlaying = !0, this.startTracker();
    }), e.on("pause", () => {
      this.trackPlayPause("pause"), this.isPlaying = !1, this.stopTracker();
    }), e.on("seeking", () => {
      const a = this.analytics.currentTime;
      typeof e.currentTime != "undefined" && this.trackSeek(a, e.currentTime), this.isSeeking = !0;
    }), e.on("seeked", () => {
      this.isSeeking = !1;
    }), e.on("error", (a) => {
      const t = a != null && a.detail ? typeof a.detail == "string" ? a.detail : "Player error" : "Unknown player error";
      this.trackError("player_error", t);
    }), e.on("enterfullscreen", () => this.trackFullscreen(!0)), e.on("exitfullscreen", () => this.trackFullscreen(!1)), e.on("timeupdate", () => {
      e.currentTime && e.duration && (this.analytics.currentTime = e.currentTime, this.analytics.duration = e.duration);
    }), e.on("ended", () => {
      this.isPlaying = !1, this.stopTracker();
    }), e.on("captionsenabled", () => {
      this.trackCaptionUsage(!0, e.language);
    }), e.on("captionsdisabled", () => {
      this.trackCaptionUsage(!1);
    }), e.on("languagechange", () => {
      this.trackCaptionUsage(!0, e.language);
    }));
  }
  registerHlsEvents(e) {
    e && (e.on(
      W.LEVEL_LOADING,
      (a, t) => {
        var s;
        if (t && t.level !== void 0 && e.levels && e.levels[t.level]) {
          const d = e.levels[t.level], f = {
            resolution: ((s = d.height) == null ? void 0 : s.toString()) || "unknown",
            bitrate: d.bitrate || 0
          };
          this.currentQuality = f, this.initializeQualityTracking(f);
        }
      }
    ), e.on(W.ERROR, (a, t) => {
      this.trackError(
        (t == null ? void 0 : t.type) || "hls_error",
        (t == null ? void 0 : t.details) || "Unknown HLS error",
        (t == null ? void 0 : t.fatal) || !1
      );
    }), e.on(
      W.LEVEL_SWITCHED,
      (a, t) => {
        var s;
        try {
          const d = e.levels;
          if (d && (t == null ? void 0 : t.level) !== void 0) {
            const f = this.currentQuality ? this.currentQuality : { resolution: "auto", bitrate: 0 }, u = d[t.level], o = u ? {
              resolution: ((s = u.height) == null ? void 0 : s.toString()) || "unknown",
              bitrate: u.bitrate || 0
            } : { resolution: "auto", bitrate: 0 };
            this.trackQualityChange(f, o);
          }
        } catch (d) {
        }
      }
    ), e.on(W.BUFFER_CREATED, () => {
      this.setUsedStandardPlayback(!1);
    }));
  }
  calculateUxScore() {
    let e = 100;
    const a = this.analytics.totalWatchTimeSecs + this.analytics.totalBufferingTimeSecs;
    if (a <= 0) return 0;
    const t = this.analytics.totalBufferingTimeSecs / a, s = Math.min(50, Math.floor(t * 100));
    e -= s;
    const d = Math.min(50, this.analytics.totalFatalErrorsCount * 10);
    return e -= d, Math.max(0, e);
  }
  calculateFluidityIndex() {
    if (this.analytics.totalWatchTimeSecs === 0) return 0;
    let e = 100;
    const a = this.analytics.totalBufferingTimeSecs / (this.analytics.totalWatchTimeSecs + this.analytics.totalBufferingTimeSecs);
    e -= Math.min(50, a * 100), e -= Math.min(25, this.analytics.totalFatalErrorsCount * 5);
    const t = Math.max(
      0,
      this.analytics.totalQualityChangeCount - 3
    );
    return e -= Math.min(15, t * 3), Math.max(0, Math.round(e));
  }
  generateSessionId() {
    const e = Date.now();
    let a = "";
    const t = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
    for (let s = 0; s < 6; s++) {
      const d = Math.floor(Math.random() * t.length);
      a += t.charAt(d);
    }
    return `${e}-${a}`;
  }
  detectPlatform() {
    if (typeof navigator == "undefined") return "unknown";
    const e = navigator.userAgent || navigator.vendor || "";
    return /android/i.test(e) || /iPad|iPhone|iPod/.test(e) ? "mobile" : "web";
  }
  getNetworkInfo() {
    const e = navigator == null ? void 0 : navigator.connection;
    return e ? {
      effectiveConnectionType: e.effectiveType,
      downlink: e.downlink,
      rtt: e.rtt,
      saveData: e.saveData
    } : {};
  }
  getDeviceInfo() {
    var a, t, s, d, f, u, o, l, w, b, R, P;
    const e = {
      browserName: "unknown",
      browserVersion: "unknown",
      osName: "unknown",
      osVersion: "unknown",
      deviceType: "unknown",
      screenWidth: window.screen.width,
      screenHeight: window.screen.height,
      screenDensity: window.devicePixelRatio || 1,
      viewportWidth: window.innerWidth,
      viewportHeight: window.innerHeight,
      language: navigator.language || "unknown",
      userAgent: navigator.userAgent || "unknown",
      cookiesEnabled: navigator.cookieEnabled,
      touchPoints: navigator.maxTouchPoints || 0
    };
    try {
      const c = navigator.userAgent;
      if (c.includes("Firefox/") ? (e.browserName = "Firefox", e.browserVersion = ((a = c.match(/Firefox\/([\d.]+)/)) == null ? void 0 : a[1]) || "") : c.includes("Edg/") ? (e.browserName = "Edge", e.browserVersion = ((t = c.match(/Edg\/([\d.]+)/)) == null ? void 0 : t[1]) || "") : c.includes("Chrome/") ? (e.browserName = "Chrome", e.browserVersion = ((s = c.match(/Chrome\/([\d.]+)/)) == null ? void 0 : s[1]) || "") : c.includes("Safari/") && !c.includes("Chrome/") ? (e.browserName = "Safari", e.browserVersion = ((d = c.match(/Version\/([\d.]+)/)) == null ? void 0 : d[1]) || "") : (c.includes("OPR/") || c.includes("Opera/")) && (e.browserName = "Opera", e.browserVersion = ((f = c.match(/OPR\/([\d.]+)/)) == null ? void 0 : f[1]) || ((u = c.match(/Opera\/([\d.]+)/)) == null ? void 0 : u[1]) || ""), c.includes("Windows")) {
        e.osName = "Windows";
        const h = (o = c.match(/Windows NT ([\d.]+)/)) == null ? void 0 : o[1];
        if (h) {
          const p = {
            "10.0": "10/11",
            "6.3": "8.1",
            "6.2": "8",
            "6.1": "7",
            "6.0": "Vista",
            "5.1": "XP"
          };
          e.osVersion = p[h] || h;
        }
      } else c.includes("Mac OS X") ? (e.osName = "macOS", e.osVersion = ((w = (l = c.match(/Mac OS X (\d+[._]\d+[._\d]*)/)) == null ? void 0 : l[1]) == null ? void 0 : w.replace(/_/g, ".")) || "") : c.includes("Android") ? (e.osName = "Android", e.osVersion = ((b = c.match(/Android ([\d.]+)/)) == null ? void 0 : b[1]) || "") : c.includes("iOS") || c.includes("iPhone OS") || c.includes("iPad") ? (e.osName = "iOS", e.osVersion = ((P = (R = c.match(/OS ([\d_]+)/)) == null ? void 0 : R[1]) == null ? void 0 : P.replace(/_/g, ".")) || "") : c.includes("Linux") && (e.osName = "Linux");
      c.includes("Mobile") ? e.deviceType = "mobile" : c.includes("Tablet") || c.includes("iPad") ? e.deviceType = "tablet" : e.deviceType = "desktop";
      const L = /\(([^;]+);/, y = c.match(L);
      y && y[1] && (e.deviceModel = y[1].trim()), navigator.hardwareConcurrency && (e.cpuCores = navigator.hardwareConcurrency), navigator != null && navigator.deviceMemory && (e.memoryGB = navigator.deviceMemory), this.tryGetBatteryInfo(e);
    } catch (c) {
    }
    return e;
  }
  /**
   * Tries to get battery information if available
   * @param info Device info object to update
   */
  tryGetBatteryInfo(e) {
    return v(this, null, function* () {
      try {
        if (navigator != null && navigator.getBattery) {
          const a = yield navigator.getBattery();
          e.batteryLevel = Math.round(a.level * 100), e.batteryCharging = a.charging;
        }
      } catch (a) {
      }
    });
  }
  initializeQualityTracking(e) {
    const a = `${e.resolution}p`;
    return this.analytics.watchTimePerQualitySecs[a] || (this.analytics.watchTimePerQualitySecs[a] = 0), this.analytics.totalDurationPerQualitySecs[a] || (this.analytics.totalDurationPerQualitySecs[a] = 0), this.analytics.bufferingPerQualitySecs[a] || (this.analytics.bufferingPerQualitySecs[a] = 0), a;
  }
  finalizeAnalytics(e) {
    try {
      const a = this.calculateBufferingTime();
      this.analytics.bufferingPerQualitySecs = a.bufferingPerQualitySecs, this.analytics.totalBufferingTimeSecs = a.totalBufferingTimeSecs, this.analytics.endTimeUTC = Date.now(), e && (this.analytics.currentTime = e.currentTime || 0, this.analytics.duration = e.duration || 0, e.duration > 0 && (this.analytics.completionPercentage = e.currentTime / e.duration * 100)), this.analytics.totalSessionDurationSecs = this.analytics.totalWatchTimeSecs + this.analytics.totalBufferingTimeSecs, this.analytics.totalBufferingCount = this.bufferingEvents.length, this.analytics.totalSeekCount = this.seekEvents.length, this.analytics.totalErrorCount = this.errorEvents.length, this.analytics.totalQualityChangeCount = this.qualityChangeEvents.length, this.analytics.playPauseCount = this.playPauseEvents.length, this.analytics.fullscreenCount = this.fullscreenEvents.filter(
        (s) => s.isFullscreen
      ).length, this.analytics.mostUsedResolution = this.determineMostUsedResolution(), this.analytics.uxScore = this.calculateUxScore();
      const t = this.normalizeAndSortHotSpots(this.viewMap);
      this.analytics.hotSpots = t.hotSpots, this.analytics.mostWatchedSegment = t.mostWatchedSegment, this.analytics.playbackFluidityIndex = this.calculateFluidityIndex(), this.analytics.mostUsedCaption = this.determineMostUsedCaption();
    } catch (a) {
    }
    return this.analytics;
  }
  exportAnalytics() {
    return v(this, null, function* () {
      this.stopTracker();
      try {
        const e = this.finalizeAnalytics(), a = `${ot().ASSETS_DRM_API_URL}/assets-license/${this.analytics.licenseId}/analytics`;
        try {
          (yield fetch(a, {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({ analytics: e }),
            credentials: "omit",
            // Explicitly omit credentials (cookies, etc.)
            keepalive: !0
            // Similar to sendBeacon, keeps request alive after page unload
          })).ok;
        } catch (t) {
        }
      } catch (e) {
      }
    });
  }
  dispose() {
    this.stopTracker();
  }
}
const Ot = {
  key: 0,
  class: "error-screen"
}, Ft = {
  key: 1,
  class: "status-screen"
}, _t = { class: "title" }, Bt = {
  key: 0,
  class: "description"
}, Mt = ["type", "poster"], Ut = ["kind", "label", "srclang", "src", "default"], Vt = 5, Dt = /* @__PURE__ */ re({
  __name: "VideoPlayer",
  props: {
    licenseId: {},
    width: { default: "100%" },
    playRaw: { type: Boolean, default: !1 },
    completionPercentage: { default: 0 },
    borderRadius: { default: "0.375rem" },
    primaryColor: { default: "#ffffff95" },
    controlsBgColor: { default: "#1D2939" },
    menuBgColor: { default: "#ffffff" },
    textColor: { default: "#fff" },
    thumbnail: {},
    subtitles: { default: () => ({}) },
    getProcessingStatus: {},
    source: {}
  },
  emits: ["onPause", "onEnded", "onPlay", "onReady", "onError", "getVideoTime", "onCaptionsEnabled", "onCaptionsDisabled", "onLanguageChange"],
  setup(i, { expose: e, emit: a }) {
    const t = i, s = a, d = g(!0), f = g(!1), u = g(null), o = g(null), l = g(null), w = g(0), b = g(3), R = g(1), P = g(!1), c = g(null), L = g(null), y = g(null), h = g([]), p = g([]), K = g("portrait-primary"), O = g({
      enterFullscreen: null,
      exitFullscreen: null
    }), D = g(!1), x = g(null), de = g(!1), Fe = N(() => t.textColor || t.primaryColor), fe = N(() => ({
      "--theme-color": t.primaryColor,
      "--border-radius": t.borderRadius,
      "--controls-bg-color": t.controlsBgColor,
      "--menu-bg-color": t.menuBgColor,
      "--text-color": Fe.value
    })), X = N(
      () => {
        var n, r, m;
        return wt(
          (n = t.source) == null ? void 0 : n.status,
          (r = t.source) == null ? void 0 : r.createdAt,
          (m = t.source) == null ? void 0 : m.updatedAt
        );
      }
    ), _e = N(() => {
      var n;
      return ((n = t.source) == null ? void 0 : n.status) === F.UNCODABLE ? !1 : d.value;
    }), he = N(
      () => {
        var n, r;
        return !t.playRaw && pt(
          (n = t.source) == null ? void 0 : n.status,
          (r = t.source) == null ? void 0 : r.processedUrl
        );
      }
    );
    function Be() {
      if (!u.value) return;
      const n = u.value;
      n.requestFullscreen ? (n.requestFullscreen(), D.value = !0) : n.webkitRequestFullscreen ? (n.webkitRequestFullscreen(), D.value = !0) : n.webkitEnterFullscreen ? (n.webkitEnterFullscreen(), D.value = !0) : n.msRequestFullscreen && (n.msRequestFullscreen(), D.value = !0);
    }
    const Me = (n) => {
      var r, m;
      K.value = n.type, K.value.includes("landscape") && ((m = (r = o.value) == null ? void 0 : r.fullscreen) != null && m.enter ? o.value.fullscreen.enter() : Be());
    };
    function Y() {
      if (!u.value || !o.value) return;
      O.value.enterFullscreen = () => v(this, null, function* () {
        if (D.value = !0, M()) {
          switch (K.value) {
            case "landscape-secondary":
              yield z("landscape-secondary");
              break;
            case "portrait-secondary":
            case "portrait-primary":
            case "landscape-primary":
              yield z("landscape-primary");
              break;
          }
          yield Rt();
        }
      }), O.value.exitFullscreen = () => v(this, null, function* () {
        D.value = !1, M() && (yield z("portrait-primary"), yield Lt());
      }), o.value.on(
        "enterfullscreen",
        O.value.enterFullscreen
      ), o.value.on(
        "exitfullscreen",
        O.value.exitFullscreen
      );
      const n = u.value;
      n.addEventListener(
        "webkitbeginfullscreen",
        O.value.enterFullscreen
      ), n.addEventListener(
        "webkitendfullscreen",
        O.value.exitFullscreen
      );
    }
    function Ue() {
      if (!u.value || !o.value) return;
      o.value.off(
        "enterfullscreen",
        O.value.enterFullscreen
      ), o.value.off(
        "exitfullscreen",
        O.value.exitFullscreen
      );
      const n = u.value;
      n.removeEventListener(
        "webkitbeginfullscreen",
        O.value.enterFullscreen
      ), n.removeEventListener(
        "webkitendfullscreen",
        O.value.exitFullscreen
      );
    }
    const Ve = () => {
      var n;
      (n = t.source) != null && n.url && !L.value && !t.playRaw && (L.value = setInterval(() => v(this, null, function* () {
        yield De();
      }), Vt * 1e3));
    }, De = () => v(this, null, function* () {
      var n, r, m, T, Q;
      try {
        if (Re(
          (n = t.source) == null ? void 0 : n.status,
          (r = t.source) == null ? void 0 : r.processedUrl
        ) || yt(
          (m = t.source) == null ? void 0 : m.status,
          (T = t.source) == null ? void 0 : T.createdAt,
          (Q = t.source) == null ? void 0 : Q.updatedAt
        )) {
          me();
          return;
        }
        t.getProcessingStatus();
      } catch ($t) {
      }
    }), me = () => {
      L.value && (clearInterval(L.value), L.value = null);
    }, ve = (n = !1) => {
      var r;
      return n ? !0 : !((r = t == null ? void 0 : t.source) != null && r.processedUrl);
    }, Ae = (n) => {
      n.on("play", (r) => {
        l.value && l.value.startLoad(n.currentTime), s("onPlay", r), P.value = !0;
      }), n.on("error", (r) => {
        f.value = !0, w.value < b.value && (A(), w.value += 1);
      }), n.on("pause", (r) => {
        s("onPause", r);
      }), n.on("timeupdate", () => {
        s("getVideoTime", [n.currentTime, n.duration]);
      }), n.on("canplay", () => P.value = !0), n.on("waiting", () => P.value = !1), n.on("playing", () => P.value = !0), n.on("ended", (r) => {
        s("onEnded", r);
      }), n.on("captionsenabled", () => {
        s("onCaptionsEnabled");
      }), n.on("captionsdisabled", () => {
        s("onCaptionsDisabled");
      }), n.on("languagechange", () => {
        s("onLanguageChange", n.language);
      });
    }, ge = (n) => v(this, null, function* () {
      f.value || (y.value && (clearTimeout(y.value), y.value = null), d.value = !1, n && s("onReady", n), yield Ye());
    }), Ne = (n = 1500) => {
      y.value && clearTimeout(y.value), y.value = setTimeout(() => {
        d.value && ge();
      }, n);
    }, J = (n) => {
      x.value && o.value && !de.value && (x.value.init(o.value), de.value = !0), n.once("loadedmetadata", () => {
        const r = n.playing;
        r && n.stop(), setTimeout(() => r && n.play(), 0);
      }), n.once("canplay", (r) => {
        const m = t.completionPercentage * n.duration / 100;
        t.completionPercentage >= 100 ? n.currentTime = Math.max(0, n.duration - 1) : n.currentTime = m, l.value && l.value.startLoad(n.currentTime), ge(r);
      }), Ae(n);
    }, Qe = (n) => {
      n === 0 ? l.value.currentLevel = -1 : l.value.levels.forEach((r, m) => {
        r.height === n && (l.value.currentLevel = m);
      });
    }, ze = () => {
      l.value && (l.value.destroy(), l.value = null);
    }, ye = () => {
      u.value && (u.value.src = t.source.url, o.value = Z(), Y(), J(o.value));
    }, Z = (n) => {
      const r = I({
        autoplay: !1,
        speed: { selected: 1, options: [0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75, 2] },
        keyboard: { focused: !0, global: !0 },
        fullscreen: {
          enabled: !0,
          fallback: !0,
          iosNative: !0,
          container: null
        },
        controls: [
          "rewind",
          "play-large",
          "play",
          "fast-forward",
          "progress",
          "current-time",
          "duration",
          "mute",
          "volume",
          "captions",
          "settings",
          "airplay",
          "pip",
          "fullscreen"
        ],
        seekTime: 5,
        captions: {
          active: h.value.length > 0,
          language: "auto",
          update: !0
        }
      }, n);
      return new ut(u.value, r);
    }, He = () => v(this, null, function* () {
      if (!_.isSupported()) {
        yield je();
        return;
      }
      const n = /Android|iPhone|iPad|iPod|webOS|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      ), r = (navigator == null ? void 0 : navigator.hardwareConcurrency) && (navigator == null ? void 0 : navigator.hardwareConcurrency) <= 4 || // @ts-expect-error - deviceMemory is not in all browsers
      (navigator == null ? void 0 : navigator.deviceMemory) && (navigator == null ? void 0 : navigator.deviceMemory) <= 4, m = n || r ? {
        maxBufferLength: 20,
        // 20 seconds for mobile/low-end devices
        maxMaxBufferLength: 40,
        // Cap at 40 seconds
        maxBufferSize: 30 * 1e3 * 1e3,
        // 30 MB - safe for Android devices
        maxBufferHole: 0.5,
        enableWorker: !0
        // Offload processing to Web Worker
      } : {
        maxBufferLength: 30,
        // 30 seconds for desktop/high-end devices
        maxMaxBufferLength: 60,
        // Cap at 60 seconds
        maxBufferSize: 60 * 1e3 * 1e3,
        // 60 MB for better desktop experience
        maxBufferHole: 0.5,
        enableWorker: !0
      };
      l.value = new _(m);
      const T = yield be();
      l.value.loadSource(
        `${t.source.processedUrl}?token=${T}`
      ), l.value.on(_.Events.LEVEL_LOADED, We), l.value.on(_.Events.ERROR, $e), x.value && l.value && x.value.registerHlsEvents(l.value), l.value.attachMedia(u.value);
    }), We = () => {
      const n = l.value.levels.map((m) => m.height);
      n.unshift(0);
      const r = {
        default: 0,
        options: n,
        forced: !0,
        onChange: Qe
      };
      o.value = Z({
        quality: r,
        i18n: { qualityLabel: { 0: "Auto" } }
      }), Y(), J(o.value);
    }, $e = (n, r) => {
      const m = r.type === _.ErrorTypes.OTHER_ERROR && r.details === _.ErrorDetails.INTERNAL_EXCEPTION;
      if (!(!r.fatal && !m))
        switch (f.value = !0, r.type) {
          case _.ErrorTypes.MEDIA_ERROR:
            break;
          case _.ErrorTypes.NETWORK_ERROR:
          case _.ErrorTypes.OTHER_ERROR:
            qe();
            break;
        }
    }, qe = (n) => {
      R.value < b.value ? (R.value += 1, A()) : A({ useRawSource: !0 });
    }, je = () => v(this, null, function* () {
      var n;
      if ((n = u.value) != null && n.canPlayType("application/vnd.apple.mpegurl")) {
        o.value = Z(), Y(), J(o.value);
        const r = yield be();
        u.value.src = `${t.source.processedUrl}?token=${r}`, u.value.load();
      } else
        throw Error("HLS playback not supported");
    }), A = (n) => v(this, null, function* () {
      var r, m;
      if (!(!u.value || !t.source)) {
        if (d.value = !0, f.value = !1, ze(), x.value && x.value.setUsedStandardPlayback(
          ve(n == null ? void 0 : n.useRawSource)
        ), ve(n == null ? void 0 : n.useRawSource)) {
          ye();
          return;
        }
        (m = (r = t.source) == null ? void 0 : r.processedUrl) != null && m.includes(".m3u8") ? yield He() : ye(), Ne();
      }
    }), Ge = () => {
      var n, r;
      c.value = document.createElement("canvas"), c.value.width = ((n = u.value) == null ? void 0 : n.videoWidth) || 1280, c.value.height = ((r = u.value) == null ? void 0 : r.videoHeight) || 720;
    }, Ke = () => {
      const n = c.value.getContext("2d");
      u.value && n.drawImage(
        u.value,
        0,
        0,
        c.value.width,
        c.value.height
      );
    }, Xe = () => (u.value.pause(), Ke(), c.value.toDataURL("image/png"));
    function Ye() {
      return v(this, null, function* () {
        try {
          const n = yield kt(t.subtitles, p.value);
          h.value = n.captions, p.value = n.blobUrls;
        } catch (n) {
        }
      });
    }
    function Je(n) {
      var r, m, T;
      o.value && ((T = (m = (r = o.value) == null ? void 0 : r.elements) == null ? void 0 : m.buttons) != null && T.captions) && o.value.toggleCaptions(n);
    }
    function Ze(n) {
      if (o.value && o.value.elements) {
        const r = n.includes("_") ? n.split("_")[0] : n;
        o.value.language = r;
      }
    }
    te(
      () => t.source,
      (n, r) => {
        const m = (T) => T ? Object.keys(T).sort().map((Q) => `${Q}:${JSON.stringify(T[Q])}`).join("|") : "";
        m(n) !== m(r) && Ee(() => A());
      },
      { deep: !0 }
    ), te(
      () => t.subtitles,
      () => v(this, null, function* () {
        o.value && u.value && !d.value && (yield A());
      }),
      { deep: !0 }
    );
    const pe = () => {
      x.value && x.value.exportAnalytics().catch((n) => {
      });
    };
    return e({
      generateThumbnail: Xe,
      enableThumbnails: P,
      toggleCaptions: Je,
      setLanguage: Ze
    }), oe(() => v(this, null, function* () {
      x.value = new It(t.licenseId), M() && (yield z("portrait-primary"), Ct(dt(Me, 300))), window.addEventListener("beforeunload", () => {
        pe();
      }), yield gt(), Ve(), Ge(), yield A();
    })), Se(() => {
      me(), y.value && (clearTimeout(y.value), y.value = null), M() && (Oe(), z("portrait")), Ue(), xt(), pe(), Tt(p.value), x.value && x.value.dispose(), l.value && l.value.destroy(), o.value && o.value.destroy();
    }), (n, r) => {
      var m;
      return S(), C(ae, null, [
        B("div", {
          class: q([{ hide: !d.value }, "video-loader"]),
          style: V(U(I({}, fe.value), { width: t.width }))
        }, [
          f.value ? (S(), C("div", Ot, r[0] || (r[0] = [
            B("p", { class: "title" }, "Unable to load video", -1),
            B("p", { class: "description" }, " There was a problem loading the video. Please try again later. ", -1)
          ]))) : he.value ? (S(), C("div", Ft, [
            B("p", _t, ie(X.value.title), 1),
            X.value.description ? (S(), C("p", Bt, " (" + ie(X.value.description) + ") ", 1)) : H("", !0)
          ])) : H("", !0),
          _e.value && !f.value ? (S(), ne(le, { key: 2 })) : H("", !0)
        ], 6),
        B("div", {
          class: q([{ hide: d.value }, "video-player-container"]),
          style: V(U(I({}, fe.value), { width: t.width }))
        }, [
          he.value ? H("", !0) : (S(), C("video", {
            key: 0,
            id: "plyr-video",
            ref_key: "videoElement",
            ref: u,
            playsinline: "",
            preload: "auto",
            type: k(vt)(t.source.url),
            crossorigin: "anonymous",
            poster: ((m = t.source) == null ? void 0 : m.thumbnailUrl) || t.thumbnail,
            "webkit-playsinline": ""
          }, [
            (S(!0), C(ae, null, st(h.value, (T) => (S(), C("track", {
              key: T.src,
              kind: T.kind,
              label: T.label,
              srclang: T.srcLang,
              src: T.src,
              default: T.default
            }, null, 8, Ut))), 128))
          ], 8, Mt))
        ], 6)
      ], 64);
    };
  }
}), At = "https://storage.googleapis.com/revex-assets-drm-staging/static/default-video-thumbnail.png", Nt = 3, Qt = /* @__PURE__ */ re({
  __name: "ThumbnailPlayer",
  props: {
    licenseId: {},
    width: { default: "100%" },
    borderRadius: { default: "0.375rem" },
    source: {}
  },
  emits: ["onLoad", "onError"],
  setup(i, { emit: e }) {
    const a = i, t = e, s = g(!0), d = g(null), f = g(null), u = g(0), o = N(() => ({
      "--border-radius": a.borderRadius
    })), l = () => {
      f.value && (clearInterval(f.value), f.value = null);
    }, w = (R) => new Promise((P, c) => {
      d.value && (d.value.onload = () => {
        s.value = !1, t("onLoad"), P();
      }, d.value.onerror = (L) => {
        s.value = !1, t("onError", new Error("Image load failed")), c(L);
      }, d.value.src = R || At);
    }), b = () => v(this, null, function* () {
      var R;
      try {
        s.value = !0;
        const P = (R = a.source) == null ? void 0 : R.thumbnailUrl;
        yield w(P);
      } catch (P) {
        u.value < Nt && (u.value += 1, setTimeout(() => b(), 2e3));
      }
    });
    return te(
      () => a.source,
      () => Ee(() => b())
    ), oe(() => v(this, null, function* () {
      yield b();
    })), Se(() => {
      l();
    }), (R, P) => (S(), C(ae, null, [
      B("div", {
        class: q([{ hide: !s.value }, "image-loader"]),
        style: V(U(I({}, o.value), { width: a.width }))
      }, [
        Pe(le)
      ], 6),
      B("div", {
        class: q({ hide: s.value }),
        style: V(U(I({}, o.value), { width: a.width }))
      }, [
        B("img", {
          ref_key: "imageElement",
          ref: d,
          class: "viewer-image",
          style: V({ borderRadius: a.borderRadius }),
          alt: "Licensed image"
        }, null, 4)
      ], 6)
    ], 64));
  }
}), zt = { key: 0 }, Ht = { key: 1 }, Wt = /* @__PURE__ */ re({
  __name: "VideoAssetPlayer",
  props: {
    licenseId: {},
    sourceInfo: {},
    borderRadius: { default: "0.375rem" },
    width: { default: "100%" },
    token: {},
    playRaw: { type: Boolean, default: !1 },
    completionPercentage: { default: 0 },
    primaryColor: { default: "#ffffff95" },
    controlsBgColor: { default: "#1D2939" },
    menuBgColor: { default: "#ffffff" },
    textColor: { default: "#fff" },
    thumbnail: {},
    preview: { type: Boolean, default: !1 },
    subtitles: { default: () => ({}) }
  },
  emits: [
    "onPause",
    "onEnded",
    "onPlay",
    "onReady",
    "onError",
    "getVideoTime",
    "onCaptionsEnabled",
    "onCaptionsDisabled",
    "onLanguageChange"
  ],
  setup(i, { expose: e, emit: a }) {
    const t = i;
    lt(t);
    const s = a, {
      assetUrls: d,
      loading: f,
      processingStatus: u,
      isAssetLicenseDeleted: o,
      cssVariables: l,
      computedLicenseId: w,
      liveSessionStatus: b,
      getProcessingStatus: R,
      initializePlayer: P
    } = ct(t), c = g(null), L = g(!1);
    return rt(() => {
      var y;
      L.value = (y = c.value) == null ? void 0 : y.enableThumbnails;
    }), oe(() => v(this, null, function* () {
      yield P();
    })), e({
      generateThumbnail: () => {
        var y;
        return (y = c.value) == null ? void 0 : y.generateThumbnail();
      },
      enableThumbnails: L,
      toggleCaptions: (y) => {
        var h;
        return (h = c.value) == null ? void 0 : h.toggleCaptions(y);
      },
      setLanguage: (y) => {
        var h;
        return (h = c.value) == null ? void 0 : h.setLanguage(y);
      }
    }), (y, h) => k(f) ? (S(), C("div", {
      key: 0,
      class: "asset-canvas",
      style: V(U(I({}, k(l)), { width: t.width }))
    }, [
      Pe(le)
    ], 4)) : k(b) && k(b).type !== "recording-ready" ? (S(), C("div", {
      key: 1,
      class: "asset-canvas",
      style: V(U(I({}, k(l)), { width: t.width }))
    }, [
      B("p", null, ie(k(b).message), 1)
    ], 4)) : k(d).assetType === k(ke).video && !t.preview ? (S(), ne(Dt, {
      key: 2,
      ref_key: "videoPlayerRef",
      ref: c,
      "license-id": k(w),
      width: t.width,
      "play-raw": t.playRaw,
      "completion-percentage": t.completionPercentage,
      "border-radius": t.borderRadius,
      "primary-color": t.primaryColor,
      "controls-bg-color": t.controlsBgColor,
      "menu-bg-color": t.menuBgColor,
      "text-color": t.textColor,
      source: I(I({}, k(d)), k(u)),
      "get-processing-status": k(R),
      thumbnail: t.thumbnail,
      subtitles: t.subtitles,
      onOnPause: h[0] || (h[0] = (p) => s("onPause", p)),
      onOnEnded: h[1] || (h[1] = (p) => s("onEnded", p)),
      onOnPlay: h[2] || (h[2] = (p) => s("onPlay", p)),
      onOnReady: h[3] || (h[3] = (p) => s("onReady", p)),
      onOnError: h[4] || (h[4] = (p) => s("onError", p)),
      onGetVideoTime: h[5] || (h[5] = (p) => s("getVideoTime", p)),
      onOnCaptionsEnabled: h[6] || (h[6] = (p) => s("onCaptionsEnabled", p)),
      onOnCaptionsDisabled: h[7] || (h[7] = (p) => s("onCaptionsDisabled", p)),
      onOnLanguageChange: h[8] || (h[8] = (p) => s("onLanguageChange", p))
    }, null, 8, ["license-id", "width", "play-raw", "completion-percentage", "border-radius", "primary-color", "controls-bg-color", "menu-bg-color", "text-color", "source", "get-processing-status", "thumbnail", "subtitles"])) : k(u).assetType === k(ke).video && t.preview ? (S(), ne(Qt, {
      key: 3,
      "license-id": k(w),
      width: t.width,
      source: k(d)
    }, null, 8, ["license-id", "width", "source"])) : (S(), C("div", {
      key: 4,
      class: "asset-canvas",
      style: V(U(I({}, k(l)), { width: t.width }))
    }, [
      k(o) ? (S(), C("p", Ht, " The media could not be loaded, try reloading the page. If the problem continues, please contact support. ")) : (S(), C("p", zt, " The media content is no longer available, as it has been deleted. "))
    ], 4));
  }
}), Jt = /* @__PURE__ */ Ce(Wt, [["__scopeId", "data-v-dba5cb7a"]]);
export {
  le as L,
  Jt as V,
  Dt as _,
  Qt as a
};
